import { queryDataExt } from "../BaseService/index";
const GlobalConfig = new window.globalConfig();

export const getCashContractPrices = async (
  whereClause,
  selectFields,
  sortFields
) => {
  return await queryDataExt(
    `${GlobalConfig.REACT_APP_API_CASH_CONTRACT_PRICE_URL}getWithConditions`,
    whereClause,
    selectFields,
    sortFields
  );
};